<admin-layout pageTitle="Monitoramento SRG-SCL">
    <div actions class="toolbar-actions">
        <button
            mat-stroked-button
            (click)="refreshAll()"
            [disabled]="state === 'loading' || outboxState === 'loading'"
        >
            Atualizar
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="retryAll()"
            [disabled]="retryingAll || !hasFailed"
        >
            {{ retryingAll ? 'Reenviando…' : 'Reenviar erros' }}
        </button>
    </div>

    <section class="monitor">
        @if (integrationUnavailable) {
        <div class="panel center">
            <p>
                Monitoramento SRG-SCL não está disponível na API de <strong>Produção</strong> atual
                (endpoint ausente).
            </p>
            <p class="empty">Troque o banner para Homologação para usar esta tela.</p>
        </div>
        } @else {
        <div class="health-panel">
            @if (healthState === 'loading') {
            <div class="center"><mat-spinner diameter="24"></mat-spinner></div>
            } @else if (healthState === 'error') {
            <div class="center">
                <p>Não foi possível carregar a saúde da integração.</p>
                <button mat-stroked-button (click)="loadHealth()">Tentar novamente</button>
            </div>
            } @else if (healthState === 'unavailable') {
            <p class="empty">Saúde da integração indisponível nesta API.</p>
            } @else if (health.length === 0) {
            <p class="empty">Nenhuma associação configurada.</p>
            } @else {
            <div class="health-grid">
                @for (h of health; track h.tenantId) {
                <div class="health-card" [class.bad]="h.alerts.length > 0">
                    <div class="health-head">
                        <b>{{ h.tenantId }}</b>
                        <span class="health-badge" [class.off]="!h.enabled">{{ h.enabled ? 'Ativa' : 'Desligada' }}</span>
                    </div>
                    <dl>
                        <dt>Busca ativa OK</dt><dd>{{ h.activeFetch.lastOkAt ? (h.activeFetch.lastOkAt | date: 'dd/MM HH:mm') : '—' }}</dd>
                        <dt>Último envio OK</dt><dd>{{ h.outbox.lastSentAt ? (h.outbox.lastSentAt | date: 'dd/MM HH:mm') : '—' }}</dd>
                        <dt>Fila pendente</dt><dd>{{ h.outbox['PENDING'] || 0 }}</dd>
                        <dt>Fila com erro</dt><dd>{{ h.outbox['FAILED'] || 0 }}</dd>
                        <dt>Divergências</dt><dd>{{ h.divergences }}</dd>
                    </dl>
                    @if (h.alerts.length) {
                    <ul class="health-alerts">
                        @for (a of h.alerts; track a) {
                        <li>⚠ {{ healthAlertLabel(a) }}</li>
                        }
                    </ul>
                    } @else {
                    <p class="health-ok">✓ Sem alertas</p>
                    }
                </div>
                }
            </div>
            }
        </div>
        <div class="kpi-strip">
            <button
                type="button"
                class="kpi-block"
                [class.active]="viewMode === 'animals'"
                (click)="setViewMode('animals')"
            >
                <span class="kpi-title">Animais</span>
                <div class="kpi-row">
                    <span class="kpi failed" (click)="$event.stopPropagation(); setFilter('FAILED')">
                        <b>{{ data.counts['FAILED'] || 0 }}</b>
                        <span>Com erro</span>
                    </span>
                    <span class="kpi pending" (click)="$event.stopPropagation(); setFilter('PENDING')">
                        <b>{{ data.counts['PENDING'] || 0 }}</b>
                        <span>Pendentes</span>
                    </span>
                    <span class="kpi synced" (click)="$event.stopPropagation(); setFilter('SYNCED')">
                        <b>{{ data.counts['SYNCED'] || 0 }}</b>
                        <span>Enviados</span>
                    </span>
                </div>
            </button>
            <button
                type="button"
                class="kpi-block"
                [class.active]="viewMode === 'events'"
                (click)="setViewMode('events')"
            >
                <span class="kpi-title">Eventos</span>
                <div class="kpi-row">
                    <span class="kpi failed" (click)="$event.stopPropagation(); setOutboxFilter('FAILED')">
                        <b>{{ outbox.counts['FAILED'] || 0 }}</b>
                        <span>Com erro</span>
                    </span>
                    <span class="kpi pending" (click)="$event.stopPropagation(); setOutboxFilter('PENDING')">
                        <b>{{ outbox.counts['PENDING'] || 0 }}</b>
                        <span>Pendentes</span>
                    </span>
                    <span class="kpi synced" (click)="$event.stopPropagation(); setOutboxFilter('SENT')">
                        <b>{{ outbox.counts['SENT'] || 0 }}</b>
                        <span>Enviados</span>
                    </span>
                    <span class="kpi muted" (click)="$event.stopPropagation(); setOutboxFilter('DISCARDED')">
                        <b>{{ outbox.counts['DISCARDED'] || 0 }}</b>
                        <span>Descartados</span>
                    </span>
                </div>
            </button>
        </div>

        <div class="view-tabs" role="tablist">
            <button
                type="button"
                role="tab"
                [attr.aria-selected]="viewMode === 'events'"
                [class.on]="viewMode === 'events'"
                (click)="setViewMode('events')"
            >
                Saída
                <em>{{ outboxTotal }}</em>
            </button>
            <button
                type="button"
                role="tab"
                [attr.aria-selected]="viewMode === 'animals'"
                [class.on]="viewMode === 'animals'"
                (click)="setViewMode('animals')"
            >
                Animais
                <em
                    >{{
                        (data.counts['FAILED'] || 0) +
                            (data.counts['PENDING'] || 0) +
                            (data.counts['SYNCED'] || 0)
                    }}</em
                >
            </button>
            <button
                type="button"
                role="tab"
                [attr.aria-selected]="viewMode === 'inbound'"
                [class.on]="viewMode === 'inbound'"
                (click)="setViewMode('inbound')"
            >
                Entrada
            </button>
            <button
                type="button"
                role="tab"
                [attr.aria-selected]="viewMode === 'lots'"
                [class.on]="viewMode === 'lots'"
                (click)="setViewMode('lots')"
            >
                Lotes e logs
            </button>
            <button
                type="button"
                role="tab"
                [attr.aria-selected]="viewMode === 'webhook'"
                [class.on]="viewMode === 'webhook'"
                (click)="setViewMode('webhook')"
            >
                Webhook
            </button>
        </div>

        <section class="panel divergences" aria-labelledby="divergences-title">
            <div class="panel-head">
                <h2 id="divergences-title">
                    Divergências com o SRG-SCL
                    <small>{{ divergences.count }}</small>
                </h2>
                <input
                    type="search"
                    class="divergence-filter"
                    placeholder="Código do produtor"
                    aria-label="Filtrar divergências por código do produtor"
                    [(ngModel)]="divergenceProducer"
                    (keyup.enter)="loadDivergences()"
                />
                <button mat-stroked-button (click)="loadDivergences()" [disabled]="divergenceState === 'loading'">
                    Atualizar
                </button>
            </div>
            @if (divergenceState === 'loading') {
            <div class="center"><mat-spinner diameter="24"></mat-spinner></div>
            } @else if (divergenceState === 'error') {
            <div class="center">
                <p>Não foi possível carregar as divergências.</p>
                <button mat-stroked-button (click)="loadDivergences()">Tentar novamente</button>
            </div>
            } @else if (divergenceState === 'unavailable') {
            <p class="empty">Conferência de divergências indisponível nesta API.</p>
            } @else if (divergences.items.length === 0) {
            <p class="empty">Nenhuma divergência aberta. Conferência periódica do SRG-SCL sem ausências.</p>
            } @else {
            <ul class="divergence-list">
                @for (d of divergences.items; track d.producerId + d.kind) {
                <li>
                    <div class="divergence-main">
                        <strong>{{ d.producerName || d.producerCode || d.producerId }}</strong>
                        <span>{{ divergenceKindLabel(d.kind) }}: {{ d.missingCount }} ausente(s) no SRG-SCL</span>
                    </div>
                    <div class="divergence-meta">
                        @if (!d.animals?.length) {
                        <span>Amostra: {{ d.sample.join(', ') }}</span>
                        }
                        <span>Aberta há {{ daysSince(d.firstDetectedAt) }} dia(s) · última conferência {{ d.lastDetectedAt | date: 'dd/MM HH:mm' }}</span>
                    </div>
                    @if (d.animals?.length) {
                    <ul class="divergence-animals" aria-label="Animais da amostra">
                        @for (a of d.animals; track a.id + (a.eventId || '')) {
                        <li>
                            <strong>{{ a.nickname || a.name || a.id }}</strong>
                            @if (a.name && a.name !== a.nickname) { <span>{{ a.name }}</span> }
                            <span>Registro: {{ a.register || 'sem registro' }}</span>
                            @if (a.apcId) { <span>SRG-SCL: {{ a.apcId }}</span> }
                            @if (a.active === false) { <span class="inactive">inativo no HomeLeite</span> }
                            @if (a.eventId) { <span class="muted">evento {{ a.eventId.slice(0, 8) }}</span> }
                        </li>
                        }
                    </ul>
                    @if (d.missingCount > d.animals!.length) {
                    <p class="divergence-more">Amostra de {{ d.animals!.length }} de {{ d.missingCount }}.</p>
                    }
                    }
                    @if (d.tenantId) {
                    <div class="divergence-meta">
                        <span>Associação: {{ d.tenantId }}</span>
                        <button mat-stroked-button (click)="recheckDivergence(d)" [disabled]="rechecking.has(d.producerId + d.kind)">
                            {{ rechecking.has(d.producerId + d.kind) ? 'Reconferindo…' : 'Reconferir agora' }}
                        </button>
                    </div>
                    }
                </li>
                }
            </ul>
            }
        </section>

        <section class="panel origin-metrics" aria-labelledby="origin-metrics-title">
            <div class="panel-head">
                <h2 id="origin-metrics-title">
                    Envios por origem · últimos {{ metrics.days }} dias
                </h2>
                <button mat-stroked-button (click)="loadMetrics()" [disabled]="metricsState === 'loading'">
                    Atualizar
                </button>
            </div>
            @if (metricsState === 'loading') {
            <div class="center"><mat-spinner diameter="24"></mat-spinner></div>
            } @else if (metricsState === 'error') {
            <div class="center">
                <p>Não foi possível carregar as métricas.</p>
                <button mat-stroked-button (click)="loadMetrics()">Tentar novamente</button>
            </div>
            } @else if (metricsState === 'unavailable') {
            <p class="empty">Métricas por origem indisponíveis nesta API.</p>
            } @else if (metrics.origins.length === 0) {
            <p class="empty">Nenhum evento enfileirado no período.</p>
            } @else {
            <div class="table-wrap">
                <table class="metrics-table">
                    <thead>
                        <tr>
                            <th scope="col">Origem</th>
                            <th scope="col" class="num">Enviados</th>
                            <th scope="col" class="num">Com erro</th>
                            <th scope="col" class="num">Pendentes</th>
                            <th scope="col" class="num">Taxa de sucesso</th>
                            <th scope="col" class="num">Latência média</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (m of metrics.origins; track m.origin) {
                        <tr>
                            <td>{{ originMetricLabel(m.origin) }}</td>
                            <td class="num">{{ m.sent }}</td>
                            <td class="num" [class.bad]="m.failed > 0">{{ m.failed }}</td>
                            <td class="num">{{ m.pending }}</td>
                            <td class="num">{{ successRate(m) === null ? '—' : successRate(m) + '%' }}</td>
                            <td class="num">{{ latencyLabel(m.avgLatencyMs) }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            }
        </section>

        <section class="panel sync-failures" aria-labelledby="sync-failures-title">
            <div class="panel-head">
                <h2 id="sync-failures-title">
                    Falhas de sincronização do app
                    <small>{{ failures.count }}</small>
                </h2>
                <button mat-stroked-button (click)="loadFailures()" [disabled]="failuresState === 'loading'">
                    Atualizar
                </button>
            </div>
            @if (failuresState === 'loading') {
            <div class="center"><mat-spinner diameter="24"></mat-spinner></div>
            } @else if (failuresState === 'error') {
            <div class="center">
                <p>Não foi possível carregar as falhas.</p>
                <button mat-stroked-button (click)="loadFailures()">Tentar novamente</button>
            </div>
            } @else if (failuresState === 'unavailable') {
            <p class="empty">Listagem de falhas indisponível nesta API.</p>
            } @else if (failures.items.length === 0) {
            <p class="empty">Nenhuma falha pendente. As já corrigidas saem da lista sozinhas.</p>
            } @else {
            <ul class="divergence-list">
                @for (f of failures.items; track f.id) {
                <li>
                    <div class="divergence-main">
                        <strong>{{ f.producerId ? shortId(f.producerId) : 'Produtor não informado' }}</strong>
                        <span>{{ f.error || 'Erro sem detalhe' }}</span>
                    </div>
                    <div class="divergence-meta">
                        <span>
                            @if (f.status) {
                            <span>Erro {{ f.status }} · </span>
                            } @if (f.url) {
                            <span class="mono">{{ f.url }} · </span>
                            } Registro:
                            {{ shortId(f.entityId || f.animalId) }} · origem:
                            {{ f.actorType ? originMetricLabel(f.actorType) : '—' }}
                        </span>
                        <span>{{ (f.at | date: 'dd/MM/yyyy HH:mm') || '—' }}</span>
                        <button
                            mat-stroked-button
                            type="button"
                            (click)="resolveFailure(f)"
                            [disabled]="failureBusy.has(f.id)"
                            [attr.aria-label]="'Marcar falha ' + shortId(f.id) + ' como resolvida'"
                        >
                            Resolvida
                        </button>
                    </div>
                </li>
                }
            </ul>
            @if (failures.count > failures.items.length) {
            <p class="empty">Exibindo {{ failures.items.length }} de {{ failures.count }}.</p>
            }
            }
        </section>

        <div class="panel-scroll">
            @if (viewMode === 'inbound') {
            <app-inbound-panel [tenants]="tenantIds"></app-inbound-panel>
            } @else if (viewMode === 'webhook') {
            <app-webhook-panel></app-webhook-panel>
            } @else if (viewMode === 'lots') {
            <app-lots-panel [tenants]="tenantIds"></app-lots-panel>
            } @else if (viewMode === 'events') {
            <section class="panel">
                <div class="panel-head">
                    <h2>
                        Saída
                        <small>{{ outboxTotal }}</small>
                    </h2>
                    @if (outboxFilter === 'FAILED' && (outbox.counts['FAILED'] || 0) > 0) {
                    <button mat-stroked-button (click)="retryAllOutbox()" [disabled]="retryingOutbox">
                        {{ retryingOutbox ? 'Reenviando…' : 'Reenviar todos (' + outbox.counts['FAILED'] + ')' }}
                    </button>
                    }
                    <mat-button-toggle-group
                        [value]="outboxFilter"
                        (change)="setOutboxFilter($event.value)"
                        aria-label="Filtro de eventos"
                        class="filters"
                    >
                        <mat-button-toggle value="">Todos</mat-button-toggle>
                        <mat-button-toggle value="FAILED">Erro</mat-button-toggle>
                        <mat-button-toggle value="PENDING">Pend.</mat-button-toggle>
                        <mat-button-toggle value="SENT">Env.</mat-button-toggle>
                        <mat-button-toggle value="DISCARDED">Desc.</mat-button-toggle>
                        <mat-button-toggle value="SRG_FAIL" title="Eventos com falha do SRG-SCL ou de rede"
                            >SRG-SCL ({{ outbox.counts['SRG_FAIL'] || 0 }})</mat-button-toggle
                        >
                    </mat-button-toggle-group>
                </div>

                @if (outboxState === 'loading') {
                <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
                } @else if (outboxState === 'error') {
                <div class="center">
                    <p>Não foi possível carregar os eventos.</p>
                    <button mat-stroked-button (click)="loadOutbox()">Tentar novamente</button>
                </div>
                } @else if (outbox.items.length === 0) {
                <p class="empty">Nenhum evento neste filtro.</p>
                } @else {
                <div class="list">
                    @for (ev of outbox.items; track trackOutbox($index, ev)) {
                    <article class="item" [class.is-fail]="ev.status === 'FAILED'">
                        <div class="item-main">
                            <div class="item-title">
                                <strong>{{ eventLabel(ev.kind) }}</strong>
                                <em class="badge" [ngClass]="ev.status.toLowerCase()">{{
                                    outboxLabels[ev.status] || ev.status
                                }}</em>
                                <span class="meta-inline"
                                    >{{ ev.attempts }} tent. ·
                                    {{
                                        ev.sentAt || ev.lastAttemptAt || ev.queuedAt
                                            | date: 'dd/MM/yyyy HH:mm'
                                    }}</span
                                >
                            </div>
                            <small class="det" [title]="ev.animalId + ' / ' + ev.eventId">
                                Animal {{ shortId(ev.animalId) }} · Evento {{ shortId(ev.eventId) }}
                            </small>
                            <small class="det">Cadastrado por: {{ originLabel(ev) }}</small>
                            <div class="item-resp">
                                @if (ev.srgSclCode) {
                                <em class="code" [class.ok]="receiptOk(ev.srgSclCode)"
                                    >{{ receiptOk(ev.srgSclCode) ? '✓' : '✗' }} {{ ev.srgSclCode }}</em
                                >
                                {{ ev.srgSclReason }}
                                } @else if (ev.lastError) {
                                <span class="err-text">{{ ev.lastError }}</span>
                                } @else {
                                <span class="muted">sem resposta</span>
                                }
                            </div>
                            @if (reasonPt(ev); as why) {
                            <small class="det"><b>Motivo:</b> {{ why }}</small>
                            }
                            @if (ev.lastSrgFailureAt) {
                            <small class="srg-fail"
                                >⚠ SRG-SCL instável: {{ ev.srgFailureCount || 1 }} falha(s), última em
                                {{ ev.lastSrgFailureAt | date: 'dd/MM/yyyy HH:mm' }}</small
                            >
                            } @if (ev.failures?.length) {
                            <button mat-button class="fail-toggle" type="button" (click)="toggleFailures(ev)">
                                {{ outboxExpanded.has(ev.id) ? 'Ocultar' : 'Ver' }} histórico de falhas ({{
                                    ev.failures!.length
                                }})
                            </button>
                            @if (outboxExpanded.has(ev.id)) {
                            <ul class="fail-list">
                                @for (f of ev.failures; track $index) {
                                <li>
                                    <strong>{{ f.at | date: 'dd/MM/yyyy HH:mm' }}</strong>
                                    · {{ failureKindLabels[f.kind || ''] || f.kind }}
                                    @if (f.httpStatus) { · HTTP {{ f.httpStatus }} }
                                    <small class="det">{{ f.error }}</small>
                                </li>
                                }
                            </ul>
                            } } @if (ev.status === 'FAILED' && isRuleError(ev)) {
                            <p class="rule-tip">
                                Erro de regra do SRG — reenviar não resolve sozinho. Corrija o dado ou
                                use Descartar para tirar da fila.
                            </p>
                            } @if (ev.status === 'PENDING') {
                            <p class="pending-tip">Na fila de envio — aguarde ou atualize em instantes.</p>
                            }
                        </div>
                        <div class="item-actions">
                            @if (ev.status === 'FAILED' || ev.status === 'DISCARDED') {
                            <button
                                mat-stroked-button
                                (click)="outboxAction(ev, 'retry')"
                                [disabled]="outboxBusy.has(ev.id)"
                            >
                                {{ outboxBusy.has(ev.id) ? 'Fila…' : 'Reenviar' }}
                            </button>
                            } @if (ev.status === 'PENDING' || ev.status === 'FAILED') {
                            <button
                                mat-button
                                color="warn"
                                (click)="outboxAction(ev, 'discard')"
                                [disabled]="outboxBusy.has(ev.id)"
                            >
                                Descartar
                            </button>
                            }
                        </div>
                    </article>
                    }
                </div>
                @if (outboxHasMore) {
                <div class="center">
                    <button mat-stroked-button (click)="loadMoreOutbox()" [disabled]="outboxLoadingMore">
                        {{ outboxLoadingMore ? 'Carregando…' : 'Carregar mais' }}
                    </button>
                </div>
                }
                }
            </section>
            } @else {
            <section class="panel">
                <div class="panel-head">
                    <h2>Animais</h2>
                    <mat-button-toggle-group
                        [value]="filter"
                        (change)="setFilter($event.value)"
                        aria-label="Filtro de animais"
                        class="filters"
                    >
                        <mat-button-toggle value="FAILED">Erro</mat-button-toggle>
                        <mat-button-toggle value="PENDING">Pend.</mat-button-toggle>
                        <mat-button-toggle value="SYNCED">Env.</mat-button-toggle>
                        <mat-button-toggle value="">Todos</mat-button-toggle>
                        <mat-button-toggle value="UNSENT">Não env.</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                @if (filter === 'UNSENT') {
                <form class="search" (ngSubmit)="setFilter('UNSENT')">
                    <input
                        type="search"
                        name="q"
                        [(ngModel)]="search"
                        placeholder="Buscar por número/apelido"
                        aria-label="Buscar animal"
                    />
                    <button mat-stroked-button type="submit">Buscar</button>
                </form>
                } @if (state === 'loading') {
                <div class="center"><mat-spinner diameter="32"></mat-spinner></div>
                } @else if (state === 'error') {
                <div class="center">
                    <p>Não foi possível carregar os animais.</p>
                    <button mat-stroked-button (click)="load()">Tentar novamente</button>
                </div>
                } @else if (data.items.length === 0) {
                <p class="empty">Nenhum animal neste filtro.</p>
                } @else {
                <div class="list">
                    @for (it of data.items; track trackById($index, it)) {
                    <article class="item" [class.is-fail]="it.status === 'FAILED'">
                        <div class="item-main">
                            <div class="item-title">
                                <strong>{{ it.animalCode || shortId(it.animalId) }}</strong>
                                <em class="badge" [ngClass]="it.status.toLowerCase()">{{
                                    labels[it.status]
                                }}</em>
                                <span class="meta-inline"
                                    >{{ it.attempts }} tent.{{ it.manual ? ' · manual' : '' }} ·
                                    {{ it.lastAttemptAt | date: 'dd/MM/yyyy HH:mm' }}</span
                                >
                            </div>
                            <small class="criador">
                                {{ it.producerCode || it.details?.producerCode || '—' }} ·
                                {{ it.producerName || it.details?.producer || '—' }}
                            </small>
                            @if (it.details; as d) {
                            <small class="det">
                                {{ d.name || 'sem nome' }} · Reg. {{ d.register || '—' }} ·
                                {{ d.breed || '—' }}
                            </small>
                            }
                            <div class="item-resp">
                                @if (it.srgSclCode) {
                                <em class="code" [class.ok]="receiptOk(it.srgSclCode)"
                                    >{{ receiptOk(it.srgSclCode) ? '✓' : '✗' }} {{ it.srgSclCode }}</em
                                >
                                {{ it.srgSclReason }}
                                } @else if (it.lastError) {
                                <span class="err-text">{{ it.lastError }}</span>
                                } @else {
                                <span class="muted">sem resposta</span>
                                }
                            </div>
                        </div>
                        <div class="item-actions">
                            <button
                                mat-stroked-button
                                (click)="retry(it)"
                                [disabled]="retrying.has(it.animalId) || retryingAll"
                            >
                                {{ retrying.has(it.animalId) ? '…' : 'Reenviar' }}
                            </button>
                        </div>
                    </article>
                    }
                </div>
                <div class="pager">
                    <button mat-button (click)="goto(-1)" [disabled]="page === 0">Anterior</button>
                    <span>Pág. {{ page + 1 }}</span>
                    <button mat-button (click)="goto(1)" [disabled]="!hasNext">Próxima</button>
                </div>
                }
            </section>
            }
        </div>
        }
    </section>
</admin-layout>
